var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B5161;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.7,485H104.3c-11.8,0-22.9-4.6-31.3-13c-8.4-8.4-13-19.5-13-31.3V71.1c0-11.8,4.6-22.9,13-31.3 c8.4-8.4,19.5-13,31.3-13h218.4c2.8,0,5.5,1.1,7.5,3.1l117.6,117.6c2,2,3.1,4.7,3.1,7.5v285.6c0,11.8-4.6,22.9-13,31.3 C429.7,480.4,418.6,485,406.7,485z M104.3,48.2c-6.1,0-11.9,2.4-16.2,6.7c-4.3,4.3-6.7,10.1-6.7,16.2v369.6 c0,6.1,2.4,11.9,6.7,16.2c4.3,4.3,10.1,6.7,16.2,6.7h302.4c6.1,0,11.9-2.4,16.2-6.7c4.3-4.3,6.7-10.1,6.7-16.2V159.5L318.3,48.2 H104.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.1,283.4c-2.8,0-5.5-1.1-7.5-3.1l-59.7-59.7l-59.7,59.7c-3,3-7.6,4-11.6,2.3c-4-1.6-6.6-5.5-6.6-9.8V37.5 c0-5.9,4.8-10.7,10.7-10.7h134.4c5.9,0,10.7,4.8,10.7,10.7v235.2c0,4.3-2.6,8.2-6.6,9.8C291.9,283.1,290.5,283.4,289.1,283.4z  M221.9,194.9c2.7,0,5.5,1,7.5,3.1l49,49V48.2H165.4V247l49-49C216.5,195.9,219.2,194.9,221.9,194.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add-file.994ad33a5fddc454488388a332122cdb.svg";
export { ForwardRef as ReactComponent };